__turbopack_context__.v({
  "calendarMonth": "CalendarMonth-module-scss-module__P8JCcG__calendarMonth",
  "calendarWeek": "CalendarMonth-module-scss-module__P8JCcG__calendarWeek",
  "calendarWeekDays": "CalendarMonth-module-scss-module__P8JCcG__calendarWeekDays",
  "container": "CalendarMonth-module-scss-module__P8JCcG__container",
  "shimmer": "CalendarMonth-module-scss-module__P8JCcG__shimmer",
  "shimmerOverlay": "CalendarMonth-module-scss-module__P8JCcG__shimmerOverlay",
});
